module.exports = __webpack_public_path__ + "img/stoke-city.8d6fee51.png";